// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-button[data-v-e491bf60]:disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}\n.caution[data-v-e491bf60] {\n  color: #e30f0f;\n}\n", ""]);
// Exports
module.exports = exports;
